module.exports = __webpack_public_path__ + "static/banner-93c8418aa45ce1bf568564c264235505.jpg";